import { useState } from 'react'
import type { User } from '../lib/firebase'

interface Props {
  user: User | null
  canEdit: boolean
}

export function SignInChip({ user, canEdit }: Props) {
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)

  const signIn = async () => {
    setBusy(true)
    setErr(null)
    try {
      const { loginWithGoogle } = await import('../lib/firebase')
      await loginWithGoogle()
    } catch (e) {
      setErr((e as Error).message)
    } finally {
      setBusy(false)
    }
  }

  if (!user) {
    return (
      <button
        onClick={signIn}
        disabled={busy}
        className="whitespace-nowrap rounded-full border border-ink/15 bg-paper-card/80 px-3 py-1.5
                   text-xs text-ink-soft hover:bg-paper-card disabled:opacity-50"
        title={err ?? ''}
      >
        {busy ? '登入中…' : '以 Google 登入'}
      </button>
    )
  }

  return (
    <div
      className="inline-flex items-center gap-1.5 rounded-full border border-ink/15 bg-paper-card/80 p-0.5 pr-1
                 text-xs text-ink-soft"
      title={`${user.email}${canEdit ? '' : '（無編輯權）'}`}
    >
      {user.photoURL ? (
        <img src={user.photoURL} alt="" className="h-6 w-6 rounded-full" referrerPolicy="no-referrer" />
      ) : (
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-ink/10 text-[10px]">
          {(user.displayName || user.email || '?').slice(0, 1).toUpperCase()}
        </span>
      )}
      <span className="hidden max-w-[110px] truncate sm:inline">
        {canEdit ? '' : '⚠ '}
        {user.displayName || user.email}
      </span>
      <button
        onClick={async () => {
          const { logout } = await import('../lib/firebase')
          await logout()
        }}
        className="rounded-full px-2 py-0.5 hover:bg-ink/5"
        aria-label="登出"
      >
        ↩
      </button>
    </div>
  )
}
